import { action, makeObservable, observable, runInAction } from 'mobx';
import { notifyError, notifySuccess } from '../../services/notifications';
import { Store } from '../../store/store';
import { Message, StoreNode } from '../../store';
import { WindowState } from '../overlays/windowState';

type WindowProps = { 
  jobId: string, 
  teamId: string|null, 
  isPublished: boolean 
}
export class JobViewStatusWindowState
  extends StoreNode {

  readonly nodeType = 'JobViewStatusWindow';

  constructor(store: Store) {
    super(store);
    makeObservable<this, 'windowListener'>(this, {
      isLoading: observable,
      jobId: observable,
      teamId: observable,
      isPublished: observable,
      submit: action,
      windowListener: action,
      open: action,
      close: action,
    });

    this.window.listen(
      this.windowListener);
  }

  readonly window = new WindowState(this.store);

  isLoading: boolean = false;

  jobId: string | null = null;
  teamId: string | null = null;
  isPublished: boolean | null = null;

  async submit() {
    this.isLoading = true;

    const [, err] = await this.store.apiService.updateJob({
      args: {
        id: this.jobId || '',
        isPublished: !this.isPublished
      }
    });

    runInAction(async () => {
      if (err) {
        notifyError(this, 'Could not update publish status.');
      } else {
        notifySuccess(this, `Successfully ${!this.isPublished ? 'published' : 'unpublished'}.`);
        await this.store.trainerDashboardPage.refreshJobs();
      }

      this.handleSubmitFinally();
    })
  }

  handleSubmitFinally() {
    runInAction(() => {
      this.isLoading = false;
      this.close();
    })
  }

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
      case 'outsideClick':
        this.close();
        break;
    }
  }

  open({ jobId, teamId, isPublished }: WindowProps) {
    this.dispatch('Overlays', 'openWindow', { name: 'JobViewStatusWindow' });

    this.jobId = jobId;
    this.teamId = teamId;
    this.isPublished = isPublished;
  }

  close() {
    this.jobId = null;
    this.teamId = null;
    this.isPublished = null;

    this.emit('close');
    this.dispatch('Overlays', 'closeWindow');
  }
}